import { getRoute } from "@utils/route";

export const CAR_QUOTE_ROUTE_URL = '/car-insurance-quote/*';
export const CAR_QUOTE_PAGE_URL = '/car-insurance-quote';

export const routeCarQuotePage = () => getRoute(CAR_QUOTE_PAGE_URL);
